// AML Notice HTML content

export const amlNoticeHtml = `
    <section>
        <p>
            W8 Shipping LLC is committed to protecting our business and supporting the   
            logistics industry by using robust standards designed to combat and prevent the   
            misuse of our industry for illicit activities. Our mission is to deliver exceptional   
            service while remaining compliant with applicable U.S. laws and regulations   
            regarding money laundering, terrorist financing, sanctions violations, export   
            control breaches, cargo theft, and other improper conduct. We maintain a   
            comprehensive framework of internal controls to mitigate the risks associated with   
            these activities, and W8 Shipping is proud to be an industry leader and among the   
            first in our sector to establish an internal Compliance Department which continues   
            to deploy compliance controls using a risk‑based approach tailored for our segment   
            of the logistics industry, including:
        </p>
        <ul>
            <li>
                <p>Sanctions and restricted‑party screening</p>
            </li>
            <li>
                <p>Customer due diligence and enhanced KYC (Know Your Customer) verification</p>
            </li>
            <li>
                <p>Cargo screening and restricted or stolen cargo prevention</p>
            </li>
            <li>
                <p>Document and recordkeeping controls</p>
            </li>
            <li>
                <p>Transaction monitoring to prevent and detect high‑risk activity (including   
                safeguards that support our prohibition against third‑party payments, cash,   
                or money order payments)  
                </p>
            </li>
        </ul>
        <p>
            At W8 Shipping, compliance is an integral part of our business and decision-making,   
            and we even take steps to encourage our key vendors, suppliers, and downstream   
            service partners to maintain their own compliance controls to further prevent   
            financial crimes and combat the global effort to exploit our industry even after our   
            service is complete. W8 Shipping is fully committed to maintaining a culture of   
            integrity and upholding our strong internal controls so we can provide not only   
            exceptional service, but also do business in a safe and fully transparent manner 
            which makes W8 Shipping a more secure and reliable partner for our customers,   
            financial institutions, insurers, and other stakeholders around the world. 
        </p>
    </section>`;
